module.exports = __webpack_public_path__ + "static/media/plusGreen.c8010c3d.svg";